// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nxt-org-switch {
  width: 220px;
  padding-left: 10px;
}

.nxt-org-switch .mat-mdc-select-value-text {
  font-weight: bold;
  color: #333;
}

.nxt-org-switch .mat-mdc-select-value {
  text-align: left;
}

.nxt-org-switch .mat-mdc-select-disabled .mat-mdc-select-arrow svg {
  display: none;
}

.nxt-org-switch-optgroup .mat-mdc-option {
  color: rgb(44, 44, 44);
  font-size: 16px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
}

.nxt-org-switch-optgroup .mat-mdc-option.mat-mdc-option-active, .nxt-org-switch-optgroup .mat-mdc-option.mdc-list-item--selected:not(.mat-mdc-option-multiple):not(.mdc-list-item--disabled) {
  background: rgba(0, 0, 0, 0.04) !important;
}

.nxt-org-switch-optgroup .mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {
  color: #3f51b5 !important;
}

.nxt-org-switch-optgroup .mat-mdc-optgroup-label:hover, .nxt-org-switch-optgroup .mat-mdc-option:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.mat-mdc-select-panel:has(.nxt-org-switch-optgroup) {
  --mat-select-panel-background-color: #fff;
}

.nxt-org-switch .mat-mdc-form-field-subscript-wrapper {
  height: 0px;
}

@media only screen and (max-width: 820px) {
  .nxt-org-switch {
    width: auto;
    overflow: hidden;
  }
  .nxt-org-switch .mat-mdc-form-field-infix {
    width: auto;
  }
  .nxt-avatar {
    padding-left: 0px !important;
  }
  .nxt-org-switch .mat-mdc-select {
    width: auto;
    max-width: 110px;
  }
  .cdk-overlay-pane:has(.nxt-org-switch-optgroup) {
    min-width: 210px;
  }
  .cdk-overlay-pane:has(.avatar-menu) {
    min-width: 190px;
  }
}
@media only screen and (max-width: 598px) {
  .nxt-org-switch,
  .nxt-avatar {
    padding-left: 0px;
  }
  .nxt-org-switch .mat-mdc-select {
    width: auto;
    max-width: 80px;
  }
  .cdk-overlay-pane:has(.nxt-org-switch-optgroup) {
    max-width: 200px;
  }
  .cdk-overlay-pane:has(.avatar-menu) {
    max-width: 190px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/views/auth0/user-org/user-org.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,WAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AACJ;;AAEA;EACI,0CAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,gDAAA;AACJ;;AAEA;EACI,yCAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI;IACI,WAAA;IACA,gBAAA;EACN;EAEE;IACI,WAAA;EAAN;EAGE;IACI,4BAAA;EADN;EAIE;IACI,WAAA;IACA,gBAAA;EAFN;EAKE;IACI,gBAAA;EAHN;EAME;IACI,gBAAA;EAJN;AACF;AAOA;EAEI;;IAEI,iBAAA;EANN;EASE;IACI,WAAA;IACA,eAAA;EAPN;EAUE;IACI,gBAAA;EARN;EAWE;IACI,gBAAA;EATN;AACF","sourcesContent":[".nxt-org-switch{\r\n    width: 220px;\r\n    padding-left: 10px;\r\n}\r\n\r\n.nxt-org-switch .mat-mdc-select-value-text {\r\n    font-weight: bold;\r\n    color: #333;\r\n}\r\n\r\n.nxt-org-switch .mat-mdc-select-value {\r\n    text-align: left;\r\n}\r\n\r\n.nxt-org-switch .mat-mdc-select-disabled .mat-mdc-select-arrow svg {\r\n    display: none;\r\n}\r\n\r\n.nxt-org-switch-optgroup .mat-mdc-option {\r\n    color: rgb(44 44 44);\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    font-family: Roboto, sans-serif;\r\n}\r\n\r\n.nxt-org-switch-optgroup .mat-mdc-option.mat-mdc-option-active, .nxt-org-switch-optgroup .mat-mdc-option.mdc-list-item--selected:not(.mat-mdc-option-multiple):not(.mdc-list-item--disabled) {\r\n    background: rgba(0, 0, 0, .04) !important;\r\n}\r\n\r\n.nxt-org-switch-optgroup .mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {\r\n    color: #3f51b5 !important;\r\n}\r\n\r\n.nxt-org-switch-optgroup .mat-mdc-optgroup-label:hover,.nxt-org-switch-optgroup .mat-mdc-option:hover{\r\n    background-color :rgba(0, 0, 0, .04) !important;\r\n}\r\n\r\n.mat-mdc-select-panel:has(.nxt-org-switch-optgroup){\r\n    --mat-select-panel-background-color: #fff;\r\n}\r\n\r\n.nxt-org-switch .mat-mdc-form-field-subscript-wrapper {\r\n    height: 0px;\r\n}\r\n\r\n@media only screen and (max-width: 820px) {\r\n    .nxt-org-switch {\r\n        width: auto;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .nxt-org-switch .mat-mdc-form-field-infix {\r\n        width: auto;\r\n    }\r\n\r\n    .nxt-avatar {\r\n        padding-left: 0px !important;\r\n    }\r\n\r\n    .nxt-org-switch .mat-mdc-select {\r\n        width: auto;\r\n        max-width: 110px;\r\n    }\r\n\r\n    .cdk-overlay-pane:has(.nxt-org-switch-optgroup) {\r\n        min-width: 210px;\r\n    }\r\n\r\n    .cdk-overlay-pane:has(.avatar-menu) {\r\n        min-width: 190px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 598px) {\r\n\r\n    .nxt-org-switch,\r\n    .nxt-avatar {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .nxt-org-switch .mat-mdc-select {\r\n        width: auto;\r\n        max-width: 80px;\r\n    }\r\n\r\n    .cdk-overlay-pane:has(.nxt-org-switch-optgroup) {\r\n        max-width: 200px;\r\n    }\r\n\r\n    .cdk-overlay-pane:has(.avatar-menu) {\r\n        max-width: 190px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
